/**
 * ZEBAESH — PARETO: DISPLAY-ONLY WHOLE-RUPEE FORMAT
 * - Rounds displayed tier/saving prices, not discount calculations.
 * - Tracks Pareto's subsequent price updates and variant changes.
 * - Does not modify product-form, Shopify money values, checkout, or coupons.
 */
(() => {
  'use strict';
  const ROOT_SELECTOR = '.otTableOffer .omg-offer';
  const MONEY_SELECTOR = '.omg-money-discount, .omg-money-origin, .omg-quantity-save .money';
  // Display formatting: Rs.3,058.20 -> Rs.3,058; rs.339.80 -> Rs.340.
  // This intentionally does not change any underlying monetary amount.
  function wholeRupees(raw) {
    const match = String(raw).trim().match(/^rs\.?\s*([\d,]+)(?:\.(\d{1,2}))?$/i);
    if (!match) return null;
    const integer = Number(match[1].replace(/,/g, ''));
    if (!Number.isSafeInteger(integer)) return null;
    const cents = match[2] ? Number(match[2].padEnd(2, '0')) : 0;
    return `Rs.${(integer + (cents >= 50 ? 1 : 0)).toLocaleString('en-US')}`;
  }

  function formatPriceNode(node) {
    if (!(node instanceof HTMLElement)) return;
    // Pareto currently puts the money value directly inside this span.
    // Avoid replacing nested markup if the app changes its structure.
    if (node.children.length) return;
    const formatted = wholeRupees(node.textContent || '');
    if (formatted !== null && formatted !== node.textContent.trim()) {
      node.textContent = formatted;
    }
  }

  function formatVisiblePrices() {
    document.querySelectorAll(`${ROOT_SELECTOR} ${MONEY_SELECTOR}`).forEach(formatPriceNode);
  }

  function startPriceFormatter() {
    formatVisiblePrices();
    const observer = new MutationObserver(records => {
      let needReformat = false;
      for (const record of records) {
        const node = record.target;
        const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        if (element && (element.closest(ROOT_SELECTOR) || element.matches(ROOT_SELECTOR))) {
          needReformat = true;
          break;
        }
        if ([...record.addedNodes].some(added => added.nodeType === Node.ELEMENT_NODE &&
          (added.matches?.('.otTableOffer') || added.querySelector?.(ROOT_SELECTOR)))) {
          needReformat = true;
          break;
        }
      }
      if (needReformat) formatVisiblePrices();
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  function start() {
    startPriceFormatter();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
